import gql from 'graphql-tag'

const updateEuroRateMutation = gql`
mutation updateCashRegisterEuroRate($cashRegisterId: ID!, $additionPercent: Float) {
	cashAssist {
		updateCashRegisterEuroRate(cashRegisterId: $cashRegisterId, additionPercent: $additionPercent) {
			exchangeRate
            exchangeRateIsUsed
            exchangeDateRefresh
            additionPercent
		}
	}
}
`
export default updateEuroRateMutation
